module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52ccc252!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/header-bidding/ConfigHbTemplate.vue
// module id = 695
// module chunks = 2